import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import { FIELD_TYPE } from '../types';
import type { FieldType } from '../types';
import { FIELD_REGISTRY } from '../registry/field-registry';

interface FieldTypeListProps {
  onSelectType: (type: FieldType) => void;
  selectedType?: FieldType;
  compact?: boolean;
}

const FIELD_TYPE_ORDER: FieldType[] = [
  FIELD_TYPE.Text,
  FIELD_TYPE.Number,
  FIELD_TYPE.Date,
  FIELD_TYPE.Select,
  FIELD_TYPE.MultiSelect,
  FIELD_TYPE.Checkbox,
  FIELD_TYPE.Users,
  FIELD_TYPE.Email,
  FIELD_TYPE.Url,
  FIELD_TYPE.Phone,
  FIELD_TYPE.Currency,
  FIELD_TYPE.Files,
  FIELD_TYPE.Signature,
];

export function FieldTypeList({ onSelectType, selectedType, compact = false }: FieldTypeListProps) {
  const { t } = useTranslation('customFields');

  return (
    <div
      data-testid="custom-fields-type-list"
      className={cn('grid gap-1 p-2', compact ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2')}
    >
      {FIELD_TYPE_ORDER.map((type) => {
        const entry = FIELD_REGISTRY[type];
        const Icon = entry.icon;
        const isSelected = selectedType === type;

        return (
          <button
            key={type}
            type="button"
            data-testid={`custom-fields-type-item-${type}`}
            onClick={() => onSelectType(type)}
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-2 text-sm text-left transition-colors',
              'hover:bg-accent',
              isSelected && 'bg-accent ring-2 ring-ring ring-offset-1',
            )}
            aria-pressed={isSelected}
          >
            <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
            <span>{t(entry.labelKey.replace('customFields.', ''))}</span>
          </button>
        );
      })}
    </div>
  );
}
